import { Question } from '../types';

/**
 * Utility functions for working with questions
 * Centralized to avoid duplication across components
 */

/**
 * Get question type from question object
 */
export function getQuestionType(question: Question): string | null {
  if (question.question_type) {
    return question.question_type;
  }
  if (question.multiple_choice_question) return 'multiple_choice_question';
  if (question.single_choice_question) return 'single_choice_question';
  if (question.true_or_false_question) return 'true_or_false_question';
  return null;
}

/**
 * Get question text from question object
 */
export function getQuestionText(question: Question, questionType: string | null): string {
  if (!questionType) return '';
  
  if (questionType === 'multiple_choice_question') {
    return question.multiple_choice_question?.question || '';
  }
  if (questionType === 'single_choice_question') {
    return question.single_choice_question?.question || '';
  }
  if (questionType === 'true_or_false_question') {
    return question.true_or_false_question?.question || '';
  }
  return '';
}

